module.exports = __webpack_public_path__ + "6edd67ba70c7374f315d78632d0f7425.pdf";